export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "contextWorker.561236c9.worker.js");
}
